"use client";

import { PropsWithChildren, useEffect, useLayoutEffect } from "react";
import {
  animateMonterIn,
  animateMonterOut,
  findMonterElement,
} from "./monter-animation";
import { registerMonterHide, shouldRevealMonter } from "./monter-live-watcher";

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

type MonterRevealProps = PropsWithChildren<{
  sectionId: string;
}>;

// Animerar in "Monter - live" när den publiceras under besöket och ut när den
// avpubliceras. Vid vanlig sidladdning visas den direkt utan animation.
// Renderar inget eget element, så att sidans layout inte påverkas.
const MonterReveal = ({ sectionId, children }: MonterRevealProps) => {
  // Layout-effekt så att animationen startar innan första ritningen
  useIsomorphicLayoutEffect(() => {
    if (!shouldRevealMonter()) return;

    const el = findMonterElement(sectionId);
    if (el) animateMonterIn(el);
  }, [sectionId]);

  useEffect(
    () =>
      registerMonterHide(sectionId, async () => {
        const el = findMonterElement(sectionId);
        if (el) await animateMonterOut(el);
      }),
    [sectionId],
  );

  return <>{children}</>;
};

export default MonterReveal;
